export const ruRu = ({
  delete_permission_tags: {
    buttons: {
      delete: 'Удалить',
    },
    toast: {
      success: 'Тег доступа успешно удален',
      error: 'Не удалось удалить тег доступа',
    },
    confirmation: {
      title: 'Удаление тега',
      subtitle: 'Вы уверены, что хотите удалить тег?',
      buttons: {
        cancel: 'Отмена',
        delete: 'Удалить',
      },
    },
  },
}) as Record<string, unknown>;

export const en = ({
  delete_permission_tags: {
    buttons: {
      delete: 'Delete',
    },
    toast: {
      success: 'Permission tag deleted successfully',
      error: 'Failed to delete permission tag',
    },
    confirmation: {
      title: 'Delete Tag',
      subtitle: 'Are you sure you want to delete the tag?',
      buttons: {
        cancel: 'Cancel',
        delete: 'Delete',
      },
    },
  },
}) as Record<string, unknown>;

export const ptBr = ({
  delete_permission_tags: {
    buttons: {
      delete: 'Excluir',
    },
    toast: {
      success: 'Tag de permissão excluída com sucesso',
      error: 'Falha ao excluir a tag de permissão',
    },
    confirmation: {
      title: 'Excluir Tag',
      subtitle: 'Tem certeza que deseja excluir a tag?',
      buttons: {
        cancel: 'Cancelar',
        delete: 'Excluir',
      },
    },
  },
}) as Record<string, unknown>;

export const esEs = ({
  delete_permission_tags: {
    buttons: {
      delete: 'Eliminar',
    },
    toast: {
      success: 'Etiqueta de acceso eliminada con éxito',
      error: 'Error al eliminar la etiqueta de acceso',
    },
    confirmation: {
      title: 'Eliminar etiqueta',
      subtitle: '¿Está seguro de que desea eliminar la etiqueta?',
      buttons: {
        cancel: 'Cancelar',
        delete: 'Eliminar',
      },
    },
  },
}) as Record<string, unknown>;
